import React, { useState, useEffect, useRef } from "react";
import PhotoCameraSvg from "../../assets/images/photo-camera.svg";
import ProfileAvatar from "../../assets/images/avatar.svg";
import Modal from "react-bootstrap/Modal";
import { Info } from "../../stories/Button.stories";
import { Primary } from "../../stories/Button.stories";
import userService from "../../services/user.service";
import ToastBlockContainer from "../../common/ToastBlockContainer";
import "./ImagePicker.scss";

function ImagePicker({ setProfileModalOpen, newProPicImg }) {
  const myRef = useRef(null);
  const DEFAULT_AVATAR = localStorage.getItem("defaultusrImgg");
  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  var UserDetails = JSON.parse(localStorage.getItem("UserDetails"));
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [successToast, setSuccessToast] = useState(false);
  const [hello, setHello] = useState(false);
  // view modal
  const [showPayment, setShowPayment] = useState(false);
  const handlePaymentClose = () => setShowPayment(false);
  const handlePaymentShow = () => {
    setShowPayment(true);
  };
  const [showDelete, setShowDelete] = useState(false);
  // Delete confirmation
  const handleShowDeleteShow = (id) => {
    setShowDelete(true);
  };
  // Close delete confirmation
  const handleShowDeleteClose = () => {
    setShowDelete(false);
  };
  // Delete task
  const handleDeleteSubscription = () => {
    // setShowDelete(false);

    var data = {
      avatar: DEFAULT_AVATAR,
    };
    userService.updateUserProfile(UserDetails.uuid, data).then(
      (res) => {
        UserDetails.avatar = res.userData[1].avatar;
        setLoading(false);
        setShowDelete(false);
        setHello(true);
        localStorage.setItem("UserDetails", JSON.stringify(UserDetails));
        setShowToast(true);
        setSuccessToast(true);
        setToastMessage("file deleted successfully");
        setTimeout(function () {
          window.location.reload();
        }, 3000);
      },
      (error) => {
        setLoading(false);
      }
    );
  };
  useEffect(() => {
    document.addEventListener("click", function (event) {
      //function to detect click inside and outside of modal

      var imagePickerModal = document.getElementsByClassName(
        "imagepicker-modal"
      )[0];
      var addIcon = document.getElementsByClassName("imagepicker-addicon")[0];

      var isClickInsideModal = imagePickerModal?.contains(event.target);
      var isClickInsideAddIcon = addIcon?.contains(event.target);

      if (!isClickInsideModal && !isClickInsideAddIcon) {
        setModalVisible(false);
      } else {
        setModalVisible(true);
      }
    });
  }, []);

  return (
    <>
      <ToastBlockContainer
        successToast={successToast}
        showToast={showToast}
        setShowToast={setShowToast}
        toastMessage={toastMessage}
      />
      <div className="mt-3 mb-5 imagepicker">
        {newProPicImg !== DEFAULT_AVATAR ? (
          <>
            <div
              className="position-relative"
              style={{ width: "150px", height: "150px" }}
            >
              <div className="imagepicker-imgHolder">
                <img
                  id="imagepicker-img"
                  src={newProPicImg ? newProPicImg : ProfileAvatar}
                  alt=""
                />
              </div>
              <div
                onClick={() => {
                  setModalVisible(true);
                }}
                className="imagepicker-addicon"
              >
                <img src={PhotoCameraSvg} alt="" />
              </div>
              <div
                style={{ display: modalVisible ? "flex" : "none" }}
                className="imagepicker-modal w-auto p-2"
              >
                <span
                  onClick={() => {
                    handlePaymentShow();
                  }}
                  style={{
                    height: "2.5rem",
                    fontSize: "14px",
                  }}
                >
                  View Photo
                </span>
                <span
                  onClick={() => {
                    setProfileModalOpen(true);
                  }}
                  style={{
                    height: "2.5rem",
                    fontSize: "14px",
                  }}
                >
                  Upload Photo
                </span>
                {newProPicImg === DEFAULT_AVATAR ? (
                  ""
                ) : (
                  <span
                    onClick={() => {
                      handleShowDeleteShow();
                    }}
                    style={{
                      height: "2.5rem",
                      fontSize: "14px",
                    }}
                  >
                    Remove Photo
                  </span>
                )}
              </div>
            </div>
            <p className="sub-text mt-3">
              We accept PNG, JPG and JPEG. (Maximum file size 500kb)
            </p>
          </>
        ) : (
          <div
            className="imagepicker-default"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setProfileModalOpen(true);
            }}
          >
            <div className="d-flex m-auto flex-column align-items-center">
              <i class="fa fa-upload fs-36" aria-hidden="true"></i>
              <h5 className="my-2"> Upload</h5>
              <small className="help-text">
                We accept PNG, JPG and JPEG. (Maximum file size 500kb)
              </small>
            </div>
          </div>
        )}
        {/* view profile image modal */}
        <Modal
          show={showPayment}
          onHide={handlePaymentClose}
          className="payment_modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h3>View Profile Photo</h3>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="viewphoto-modal-ImgHolder">
              <img src={newProPicImg ? newProPicImg : ProfileAvatar} alt="" />
            </div>
          </Modal.Body>
        </Modal>
        {/* remove profile image modal */}
        <Modal
          show={showDelete}
          onHide={handleShowDeleteClose}
          className="invite_au_modal"
        >
          <Modal.Header closeButton>
            <Modal.Title className="mx-1 dltWizard">
              <h3 className="mb-0">Delete Photo</h3>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="mx-1">
            <p className="mb-1">Photo will be deleted from the profile.</p>
            <p>Do you want to continue?</p>
            <div className="my-2 d-flex align-items-center gap-3">
              <span>
                <Info
                  children="Cancel"
                  variant="info"
                  size="mediumbtn"
                  type=""
                  onClick={handleShowDeleteClose}
                  className="btn btn-white"
                />
              </span>
              <span className="ml-4">
                <Primary
                  children="Yes"
                  variant="primary"
                  size="mediumbtn"
                  type=""
                  onClick={() => handleDeleteSubscription()}
                  className="btn btn-primary"
                />
              </span>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default ImagePicker;
